/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Personal_Roles_BodyInputs */



/**
* | output |
* | --- |
* | "Members pick a colour, gradient, holographic finish and icon for a role of their own." |
*
* @param {Features_Personal_Roles_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_personal_roles_body = /** @type {((inputs?: Features_Personal_Roles_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Personal_Roles_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участники выбирают цвет, градиент, голографический стиль и значок для собственной роли.")
	return /** @type {LocalizedString} */ ("Members pick a colour, gradient, holographic finish and icon for a role of their own.")
});